// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__2kNS0","productName":"Table_productName__3WGHC"};